// extracted by mini-css-extract-plugin
export default {"portalPopupOverlay":"PortalPopup_portalPopupOverlay__NP6jp","popupContent":"PortalPopup_popupContent__6Uv0Y"};